import { render } from "./footer.vue?vue&type=template&id=f86d7a0c&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=f86d7a0c&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f86d7a0c"]])

export default __exports__